import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=855dd0ae&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855dd0ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('855dd0ae')) {
      api.createRecord('855dd0ae', component.options)
    } else {
      api.reload('855dd0ae', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=855dd0ae&scoped=true&", function () {
      api.rerender('855dd0ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YoILXyPla7QI/JS/comp/Accordion.vue"
export default component.exports